interface Cliente {
  id: number;
  nombre: string;
  email?: string;
  telefono?: string;
  activo?: boolean;
}

interface Props {
  cliente: Cliente | undefined;
}

export default function ClienteInfoCard({ cliente }: Props) {
  if (!cliente) return null;

  return (
    <div className="bg-white border border-brand-gray-200 rounded-2xl p-6">
      <div className="flex items-start gap-4">
        <div className="w-14 h-14 rounded-full bg-brand-sage/20 flex items-center justify-center text-brand-black shrink-0">
          <i className="ri-user-line text-xl" />
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="font-serif text-brand-black text-xl font-medium">{cliente.nombre}</h3>
          <div className="flex flex-wrap gap-x-4 gap-y-1 mt-1.5">
            {cliente.email && (
              <span className="font-sans text-brand-gray-500 text-sm">{cliente.email}</span>
            )}
            {cliente.telefono && (
              <span className="font-sans text-brand-gray-500 text-sm">{cliente.telefono}</span>
            )}
          </div>
        </div>
        <div className="shrink-0">
          {cliente.activo ? (
            <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full font-sans text-xs font-medium bg-brand-sage/20 text-brand-black">
              <span className="w-1.5 h-1.5 rounded-full bg-brand-sage" />
              Activo
            </span>
          ) : (
            <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full font-sans text-xs font-medium bg-brand-gray-100 text-brand-gray-500">
              <span className="w-1.5 h-1.5 rounded-full bg-brand-gray-400" />
              Inactivo
            </span>
          )}
        </div>
      </div>
    </div>
  );
}